import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.array.find";
import "core-js/modules/web.dom.iterable";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import border from "../com/border";
import aMap from "../com/map"; // import polylinePath from '../static/polyline.json'

import displacementPolyline from "../com/displacementPolyline";
import osmoticChart from "../com/osmoticChart";
import seepagePolyline from "../com/seepagePolyline";
import fileTable from "../com/fileTable";
import site from "../static/site.json"; // 运维分析

import maintenanceTrend from "../com/maintenanceTrend";
import { getAction } from '@/api/manage';
import moment from 'moment';
import { queryWastehydrologyCurveAnalysis } from '@/api/api';
export default {
  name: 'atmosphere',
  components: {
    border: border,
    aMap: aMap,
    displacementPolyline: displacementPolyline,
    osmoticChart: osmoticChart,
    seepagePolyline: seepagePolyline,
    fileTable: fileTable,
    maintenanceTrend: maintenanceTrend
  },
  data: function data() {
    return {
      showFileTable: false,
      dynamicColumn: [[{
        label: '站点',
        code: 'siteName'
      }, {
        label: '时间',
        code: 'dataTime'
      }, {
        label: 'x方向累计差值',
        code: 'dx'
      }, {
        label: 'y方向累计差值',
        code: 'dy'
      }, {
        label: 'z方向累计差值',
        code: 'dz'
      }], [{
        label: '站点',
        code: 'siteName'
      }, {
        label: '时间',
        code: 'dataTime'
      }, {
        label: '压力(kpa)',
        code: 'sl005'
      }], [{
        label: '站点',
        code: 'siteName'
      }, {
        label: '时间',
        code: 'dataTime'
      }, {
        label: '水位(m)',
        code: 'sl011'
      }]],
      colomn: [],
      siteArr: site,
      selectedDisplacement: '',
      selectedOsmotic: '',
      selectedSeepage: '',
      // lineArr: polylinePath,
      showDisplacement: false,
      showOsmotic: false,
      showSeepage: false,
      tabList: [],
      selectedTabId: '',
      dateList: [],
      dateListCopy: [],
      dataSource: {
        displacement: [[{
          name: 'x方向累计差值',
          data: [0.0001, 0.0001, 0.00012, 0.00008, 0.00015, 0.0003]
        }, {
          name: 'y方向累计差值',
          data: [0.0005, 0.00011, 0.00002, 0.00013, 0.00025, 0.00016]
        }, {
          name: 'z方向累计差值',
          data: [0.00015, 0.00012, 0.00017, 0.00014, 0.00015, 0.00016]
        }], [{
          name: 'x方向累计差值',
          data: [0.00012, 0.00015, 0.00018, 0.00008, 0.00002, 0.00010]
        }, {
          name: 'y方向累计差值',
          data: [0.0003, 0.00012, 0.00021, 0.00023, 0.00014, 0.00024]
        }, {
          name: 'z方向累计差值',
          data: [0.00002, 0.00011, 0.00017, 0.00016, 0.0003, 0.00002]
        }], [{
          name: 'x方向累计差值',
          data: [0.00007, 0.0006, 0.00023, 0.00026, 0.00006, 0.00009]
        }, {
          name: 'y方向累计差值',
          data: [0.00011, 0.00021, 0.00013, 0.00002, 0.00006, 0.00012]
        }, {
          name: 'z方向累计差值',
          data: [0.0001, 0.0002, 0.00006, 0.00021, 0.00007, 0.00002]
        }]],
        Osmotic: [[[22.0, 22.2, 23.3, 24.5, 26.3, 20.2], [54.6, 81.9, 97.0, 126.4, 128.7, 70.7]], [[21.2, 23.2, 22.5, 24.5, 22.3, 24.2], [62.3, 72.1, 69.2, 81.2, 126.8, 95.6]], [[23.2, 25.6, 26.1, 27.2, 24.1, 23.2], [58, 95, 65, 121, 101, 79]]],
        Seepage: [[22.0, 22.2, 23.3, 24.5, 26.3, 20.2], [34.2, 32.1, 35.6, 31.1, 28.3, 29.6], [26.4, 23.5, 27.8, 30.1, 22.4, 20.2]]
      }
    };
  },
  mounted: function mounted() {},
  watch: {
    selectedDisplacement: function selectedDisplacement(val) {
      this.showDisplacementAnalysis(val);
    },
    selectedOsmotic: function selectedOsmotic(val) {
      this.showOsmoticAnalysis(val);
    },
    selectedSeepage: function selectedSeepage(val) {
      this.showSeepageAnalysis(val);
    }
  },
  methods: {
    getSiteTab: function getSiteTab(siteTab) {
      var _this = this;

      siteTab.forEach(function (item) {
        item.id = item.type;

        if (item.type > 3) {
          item.type -= 2;

          _this.tabList.push(item);
        }
      });
      this.onToSelectedTab(this.tabList[0]);
    },
    getSiteArr: function getSiteArr(siteArr) {
      siteArr = siteArr.filter(function (item) {
        return item.st == 60;
      });
      this.site = siteArr;
      this.siteArr = siteArr;
      this.selectedDisplacement = siteArr.find(function (item) {
        return item.category == 2;
      }).id;
      this.selectedOsmotic = siteArr.find(function (item) {
        return item.category == 3;
      }).id;
      this.selectedSeepage = siteArr.find(function (item) {
        return item.category == 4;
      }).id;
      this.getSiteData();
    },
    showDisplacementAnalysis: function showDisplacementAnalysis(val) {
      var _this2 = this;

      var optionData = [];
      var xAxisData = [];
      this.getChartData(val).then(function (res) {
        if (res.success) {
          var selectedCode = ['dx', 'dy', 'dz'];
          res.result.query.factors.forEach(function (item) {
            if (selectedCode.indexOf(item.code) > -1) {
              console.log('enter');
              var obj = {
                name: item.title,
                data: []
              };
              res.result.records.forEach(function (item1) {
                obj.data.push(item1.factor && item1.factor[item.code] && item1.factor[item.code].hasOwnProperty('value') && item1.factor[item.code].value !== '' && item1.factor[item.code].value !== null ? item1.factor[item.code].value : '');
              });
              optionData.push(obj);
            }
          });
          res.result.records.forEach(function (item) {
            xAxisData.push(item.dataTime);
          });
        }

        _this2.showDisplacement = false;

        _this2.$nextTick(function () {
          _this2.showDisplacement = true;

          _this2.$nextTick(function () {
            console.log('datas', xAxisData, optionData);

            _this2.$refs.displacementRef.initBarChart(xAxisData, optionData);
          });
        });
      }).catch(function () {
        _this2.showDisplacement = false;

        _this2.$nextTick(function () {
          _this2.showDisplacement = true;

          _this2.$nextTick(function () {
            console.log('datas', xAxisData, optionData);

            _this2.$refs.displacementRef.initBarChart(xAxisData, optionData);
          });
        });
      });
    },
    showOsmoticAnalysis: function showOsmoticAnalysis(val) {
      var _this3 = this;

      var optionData = [];
      var xAxisData = [];
      this.getChartData(val).then(function (res) {
        if (res.success) {
          var tempArr = [];
          var paArr = [];
          res.result.records.forEach(function (item) {
            xAxisData.push(item.dataTime);
            tempArr.push(item.factor && item.factor['sl004'] && item.factor['sl004'].hasOwnProperty('value') && item.factor['sl004'].value !== null && item.factor['sl004'].value !== '' ? item.factor['sl004'].value : '');
            paArr.push(item.factor && item.factor['sl005'] && item.factor['sl005'].hasOwnProperty('value') && item.factor['sl005'].value !== null && item.factor['sl005'].value !== '' ? item.factor['sl005'].value : '');
          });
          optionData.push(tempArr);
          optionData.push(paArr);
        }

        console.log('initBarChart', xAxisData, optionData);
        _this3.showOsmotic = false;

        _this3.$nextTick(function () {
          _this3.showOsmotic = true;

          _this3.$nextTick(function () {
            _this3.$refs.osmoticRef.initBarChart(xAxisData, optionData);
          });
        });
      }).catch(function () {
        _this3.showOsmotic = false;

        _this3.$nextTick(function () {
          _this3.showOsmotic = true;

          _this3.$nextTick(function () {
            _this3.$refs.osmoticRef.initBarChart(xAxisData, optionData);
          });
        });
      });
    },
    showSeepageAnalysis: function showSeepageAnalysis(val) {
      var _this4 = this;

      var optionData = [];
      var xAxisData = [];
      this.getChartData(val).then(function (res) {
        if (res.success) {
          res.result.records.forEach(function (item) {
            xAxisData.push(item.dataTime);
            optionData.push(item.factor && item.factor['sl011'] && item.factor['sl011'].hasOwnProperty('value') && item.factor['sl011'].value !== null && item.factor['sl011'].value !== '' ? item.factor['sl011'].value : '');
          });
        }

        _this4.showSeepage = false;

        _this4.$nextTick(function () {
          _this4.showSeepage = true;

          _this4.$nextTick(function () {
            _this4.$refs.seepageRef.initBarChart(xAxisData, optionData);
          });
        });
      }).catch(function () {
        _this4.showSeepage = false;

        _this4.$nextTick(function () {
          _this4.showSeepage = true;

          _this4.$nextTick(function () {
            _this4.$refs.seepageRef.initBarChart(xAxisData, optionData);
          });
        });
      });
    },
    getChartData: function getChartData(scopeId) {
      var param = {
        stime: moment().format('YYYY-MM-DD'),
        etime: moment().format('YYYY-MM-DD'),
        scopeId: scopeId,
        type: 1,
        column: 'data_time',
        order: 'asc',
        dataType: 11
      };
      return new Promise(function (resolve, reject) {
        getAction('/online/st60/chart', param).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    getSiteData: function getSiteData() {
      var _this5 = this;

      this.site.forEach(function (item, index) {
        if (item.category == 1) {
          _this5.dateList.push(_objectSpread(_objectSpread({}, item), {}, {
            rainy: (item.id * 0.012).toFixed(2),
            flow: (item.id * 0.0031).toFixed(2),
            waterNum: item.name.indexOf('南雅水库') > -1 ? 16 : item.name.indexOf('尖山水库') > -1 ? 18 : (2.5 + index * 0.02).toFixed(2)
          }));
        }
      });
      this.dateListCopy = JSON.parse(JSON.stringify(this.dateList));
    },
    onToSelectedTab: function onToSelectedTab(item) {
      if (id === this.selectedTabId) {
        return;
      }

      var id = item.id;
      this.selectedTabId = id;
      this.handleDateList(item);
    },
    handleDateList: function handleDateList(data) {
      var _this6 = this;

      this.colomn = this.dynamicColumn[data.type - 2];
      this.dateList = [];
      getAction("/online/st60/siteWaterAndRain/".concat(data.type)).then(function (res) {
        if (res.success) {
          _this6.showFileTable = false;

          _this6.$nextTick(function () {
            _this6.showFileTable = true;

            _this6.$nextTick(function () {
              _this6.dateList = res.result;
            });
          });
        }
      });
    }
  }
};